import React from "react";
import protectedImg from "../../assets/images/DeathModuleNew/protected.svg";
import { useHistory } from "react-router-dom";
import { setActiveStep } from "../../redux/slices/loginSlice";
import { useDispatch } from "react-redux";

import "./deathDashboard.css";
import { ToolTipCreator } from "../../helpers/ToolTipCreator";

export const AssetsDashboard = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <div>
      {/* <div
        style={{
          display: "flex",
          marginBottom: "8px",
          width: "40%",
          justifyContent: "space-between",
        }}
      >
        <div className="audioName" style={{ background: "#D6E1FE" }}>
          Assets
        </div>
        <div className="audioName" style={{ background: "#FFE5D3" }}>
          Liability
        </div>
      </div>*/}
      <div
        className="cardHeading"
        style={{ marginTop: "1rem" }}
        onClick={() => {
          dispatch(setActiveStep(9));
          history.push("/protector/death");
        }}
      >
       <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          ASSETS & LIABILITIES DETAILS
          <ToolTipCreator name={"Death_Assets_and_Liabilities"}/>
       </div> 
      </div>
      {props.role !== "trustee" ? (
        <React.Fragment>
          <div
            className="cardDesc"
            style={{ marginTop: "8px", marginBottom: "8px" }}
          >
            This software feature is pulling information that is entered in the
            individual Assets and Liabilities modules.
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "1rem",
            }}
          >
            <div
              className="payButton"
              style={{ width: "48%" }}
              onClick={() => {
                history.push("/assets");
              }}
            >
              {" "}
              Add Assets
            </div>
            <div
              className="payButton"
              style={{ width: "48%" }}
              onClick={() => {
                history.push("/liabilities_credit");
              }}
            >
              {" "}
              Add Liabilities
            </div>
          </div>
        </React.Fragment>
      ) : (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontWeight: "700",
            fontFamily: "Poppins",
            fontSize: "14px",
            marginTop: "1rem",
            flexDirection: "column",
          }}
        >
          This information will be available to you soon!
          <img
            src={protectedImg}
            style={{ width: "50px", height: "50px", marginTop: "8px" }}
            alt="protectedImg"
          ></img>
        </div>
      )}
    </div>
  );
};
